import React from 'react';

/**
 * FixedCTA — fixed/sticky bottom call-to-action with smooth scroll to
 * an in-page anchor. Host template supplies the `className` and scroll
 * root (so sticky-in-preview-frame logic stays in the template).
 *
 * Props:
 *   href         — anchor href (e.g. '#amt-rsvp')
 *   targetId     — id of the element to scroll to (falls back to href minus '#')
 *   scrollRoot   — ref or element to querySelector within (defaults to document)
 *   className    — full class string to apply to the anchor
 *   children     — button label
 */
export default function FixedCTA({ href, targetId, scrollRoot, className, children }) {
  const onClick = (e) => {
    const id = targetId || (href || '').replace(/^#/, '');
    if (!id) return;
    const root = (scrollRoot && (scrollRoot.current || scrollRoot)) || document;
    const el = root.querySelector ? root.querySelector('#' + id) : null;
    if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  };
  return (
    <a href={href || '#'} className={className} onClick={onClick}>
      {children}
    </a>
  );
}
